var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.webVIewValidation())?[_c(_vm.layout,{tag:"component"})]:(!_vm.webVIewValidation()&&_vm.web)?_c('div',{staticClass:"sa-splash"},[_c('img',{staticClass:"sa-img-cover-custom",attrs:{"src":"https://img.litedev.com/images/static/logo.svg"}})]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }